export const GET_API_TOKEN_LIST = 'getApiTokensList';
export const DELETE_API_TOKEN_ACTION = 'deleteApiToken';
export const CREATE_API_TOKEN_ACTION = 'createApiToken';
